import http from '../../utils/fetch';
export default {
    query(query) {
        return http({
            url: '/api/swyl/v1/internalMessage/selectPage',
            method: 'post',
            params: query
        });
    },

    deleteFlagById(query) {
        return http({
            url: '/api/swyl/v1/internalMessage/deleteFlagById',
            method: 'post',
            params: query
        });
    },

    searchMsgTopList(query) {
        return http({
            url: '/api/swyl/v1/internalMessage/searchMsgTopList',
            method: 'post',
            params: query
        });
    },


    queryCheckedTotal(query) {
        return http({
            url:'/api/swyl/v1/internalMessage/internalMessageUserInfo/checkedTotal',
            method: 'post',
            params: query
        });
    },
    cancelTopUp(query) {
        return http({
            url:'/api/swyl/v1/boardJxsGap/cancelTopUp',
            method: 'post',
            params: query
        });
    },

    selectChecked(id) {
        return http({
            url:'/api/swyl/v1/internalMessage/internalMessageUserInfo/selectChecked',
            method: 'post',
            params: {id}
        });
    },
    publishMessage(query) {
        return http({
            url:'/api/swyl/v1/internalMessage/internalMessageUserInfo/publishMessage',
            method: 'post',
            params: query
        });
    }

}
